
<!-- <fuse-loading-bar></fuse-loading-bar> -->

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 dms-inner-wrapper">
    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <ng-container>
            <!-- Main view -->
            <file-manager-list *ngIf="defaultView =='explorer'" [lpm]="lpm" [defaultView]="defaultView"></file-manager-list>
            <!-- Trash view -->
            <settings-labels *ngIf="defaultView =='labels'"></settings-labels>
            <!-- Recent view -->
            <app-recents *ngIf="defaultView =='recent'" [defaultView]="defaultView"></app-recents>
            <!-- Shared view -->
            <app-favorite *ngIf="defaultView =='starred'" [lpm]="lpm" [defaultView]="defaultView"></app-favorite>

            <file-manager-trash *ngIf="defaultView =='trash'" [lpm]="lpm" [defaultView]="defaultView"></file-manager-trash>
            <file-manager-shared *ngIf="defaultView =='shared'" [lpm]="lpm" [defaultView]="defaultView"></file-manager-shared>
            <!-- Copilot Agents/Assitants view -->
            <app-copilot-settings-wc *ngIf="defaultView =='copilot-settings'" [lpm]="lpm" [defaultView]="defaultView"></app-copilot-settings-wc>
            <div [style.visibility]="(defaultView == 'upload' || !lpm?.globalUploadPopup) ? 'visible' : 'hidden'" class="absolute right-0 bottom-0 z-50">
                <upload-queue-popup style="right: 0; bottom: -50; z-index: 50;"></upload-queue-popup>
            </div>
        </ng-container>
    </div>

    <!-- Footer -->
    <!--
    <div class="relative flex flex-0 items-center w-full h-6 sm:h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Paradigm &copy; {{currentYear}}</span>
    </div>
    -->
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->



